import {Component} from '@angular/core';
import {Data, RouterOutlet} from '@angular/router';
import {routeAnimations, UnespCoreFooter, UnespCoreLayoutModule} from '@unesp/core';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    animations: [routeAnimations],
    imports: [UnespCoreLayoutModule, RouterOutlet]
})
export class AppComponent {
  fullTitle = 'e-Voto - Módulo de Inscrições - UNESP'
  shortTitle = 'Modulo de Inscrições'
  logoCustom = 'assets/img/evoto-logo.png'
  footer: UnespCoreFooter = {
    areaResponsavel: 'CTINF - Coordenadoria de Tecnologia da Informação',
    proprietario: 'CTINF - Coordenadoria de Tecnologia da Informação',
    desenvolvidoPor: 'GTDSI - Grupo Técnico de Desenvolvimento de Sistemas Institucionais',
    areaResponsavelUrl: 'https://unesp.br/ctinf',
    proprietarioUrl: 'https://unesp.br/ctinf',
    desenvolvidoPorUrl: 'https://www2.unesp.br/portal#!/gtdsi'
  }


  prepareRoute(outlet: RouterOutlet): Data {
    return outlet && outlet.activatedRouteData;
  }
}
